<div class="image-container">
  <img 
    *ngIf="imageState === 'loaded'" 
    [src]="src" 
    [alt]="alt"
    [class]="customClass"
    [style]="customStyle"
    (error)="onImageError()">
  
  <mat-icon 
    *ngIf="imageState === 'loading' || imageState === 'retrying'" 
    class="loading-icon"
    [class]="customClass"
    [style]="customStyle">
    description
  </mat-icon>
  
  <mat-icon 
    *ngIf="imageState === 'error'" 
    class="error-icon"
    [class]="customClass"
    [style]="customStyle">
    broken_image
  </mat-icon>
</div>